import { render } from "./ConfigTab.vue?vue&type=template&id=2c5e207b"
import script from "./ConfigTab.vue?vue&type=script&lang=js"
export * from "./ConfigTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__